import React from "react";
import PropTypes from "prop-types";

import AccordionItem from "./AccordionItem";

const Accordion = (props) => {
  const {
    primaryColor,
    secondaryColor,
    fillColor,
    items,
  } = props;

  return (
    <div style={styles.accordionContainer}>
      {items.map((item, index) => (
        <AccordionItem
          isActive={item.isActive}
          index={index + 1}
          title={item.title}
          subtitle={item.period}
          content={item.content}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          fillColor={fillColor}
          key={index}
        />
      ))}
    </div>
  );
};

const styles = {
  accordionContainer: {
    marginTop: "0.25rem",
    marginBottom: "0.25rem",
  },
};

Accordion.propTypes = {
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  fillColor: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    period: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
  })).isRequired,
};

export default Accordion;
